import * as React from "react";
import Modal from "react-modal";
import styled, { withTheme, ThemeProps } from "styled-components";
import { Button } from "react-bootstrap";
import { injectIntl, WrappedComponentProps } from "react-intl";
import { ITheme } from "../../../themes/types";
import { useDispatch } from "react-redux";
import { setModalStatus } from "@Safemate/Store/actions";

export const modalStyles = {
  content: {
    width: "80%",
    maxWidth: "500px",
    height: "fit-content",
    position: "unset",
    background: "",
    color: ""
  },
  overlay:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  }
}

export const ModalTitle = styled.div`
  padding: 15px;
`;

export const H2 = styled.h2`
  text-transform: lowercase;
  &::first-letter{
    text-transform: uppercase;
  }
`;

export const ModalBody = styled.div`
  padding: 0 30px;
`;

export const ModalFooter = styled.div<{buttonAlign?: string}>`
  margin: 20px 15px;
  padding: 15px;
  text-align: ${props => props.buttonAlign || "left"};
`;

export const ConfirmBtn = styled(Button)<{delete?: boolean}>`
  background: #F12638;
  color: white;
  margin-right: 10px;
  min-width: 200px;
`;

export const CancelButton = styled(Button)`
  color: white;
  background: ${props => props.theme.colors.borderColor};
  margin-right: 15px;
  @media only screen and (max-width: 557px) {
    min-width: 200px;
    margin-right: 10px;
    margin-bottom: 5px;
  }
`;


export interface ConfirmModalProps{
  title: string | null;
  body?: string | JSX.Element | null;
  afterFooter?: string | JSX.Element | null;
  info?: boolean;
  confirmText?: string | JSX.Element;
  confirmFunc?: Function;
  cancelFunc?: Function;
  cancelText?: string;
  maxWidth?: string;
  disableClose?: boolean;
  disableConfirm?: boolean;
  width?: string;
  standardBtn?: boolean;
  buttonAlign?: string;
  customFooter?: JSX.Element;
}

export interface ExtendedConfirmModalProps extends ConfirmModalProps, ThemeProps<ITheme>, WrappedComponentProps{
}

const confirmModal = () => {
  
  const [ open, setOpen ] = React.useState(false);
  Modal.setAppElement("#react");

  const dispatch = useDispatch();
    
  const setModal = (status: boolean) => {
    setOpen(status)
    dispatch(setModalStatus(status));
  }

  return{Comp: injectIntl(withTheme(({theme, standardBtn, buttonAlign, width, title, body, afterFooter, info, confirmText, confirmFunc, cancelFunc, cancelText, disableClose, disableConfirm, customFooter, intl: {formatMessage}}: ExtendedConfirmModalProps) => (
    <Modal
      isOpen={open}
      onRequestClose={() => {
        if(!disableClose)
          setModal(false)
      }}
      style={
        {
          content: {
            maxWidth: "80%",
            maxHeight: "80vh",
            minWidth: width || "400px",
            height: "fit-content",
            position: "unset",
            background: theme.colors.backgroundPrimary,
            color: ""
          },
          overlay:{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 5
          }
        }
      }
    >
      {title &&
      <ModalTitle>
        <H2>{title}</H2>
      </ModalTitle>}
      {body &&
      <ModalBody>
        {body}
      </ModalBody>}
      {customFooter || <ModalFooter buttonAlign={buttonAlign}>
        {info 
          ? 
            <CancelButton onClick={() => cancelFunc ? cancelFunc() : setModal(false)}>
              {formatMessage({id: "ok", defaultMessage: "OK"})}
            </CancelButton>
          :
            <React.Fragment>
              <CancelButton
                onClick={() => cancelFunc ? cancelFunc() : setModal(false)}>
                {cancelText || formatMessage({id: "cancel", defaultMessage: "Avbryt"})}
              </CancelButton>
              {standardBtn
                ? <Button disabled={disableConfirm} onClick={() => (!disableConfirm && confirmFunc) && confirmFunc()}>{confirmText}</Button>  
                : <ConfirmBtn disabled={disableConfirm} onClick={() => (!disableConfirm && confirmFunc) && confirmFunc()}>{confirmText}</ConfirmBtn>}
            </React.Fragment>
        }
      </ModalFooter>}
      {afterFooter && 
        <ModalBody>
          {afterFooter}
        </ModalBody>}
    </Modal>
  ))), func: setModal}
}

export default confirmModal;